module.exports = __webpack_public_path__ + "static/media/tab-homologation.73fc973a.svg";